module.exports = __webpack_public_path__ + "static/media/pic5.bc8f7f8d.jpg";